import { defineMessages } from 'react-intl';

export default defineMessages({
    anErrorOccurred: {
        id: 'quoteandbind.farm.wizard.error.cancel',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.farm.wizard.error.cancel.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'quoteandbind.farm.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.farm.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    packageDetails: {
        id: 'quoteandbind.farm.wizard.step.Package Details',
        defaultMessage: 'Package Details'
    },
    packageInfo: {
        id: 'quoteandbind.farm.wizard.step.Farmer Details',
        defaultMessage: 'Farmer\'s Accident'
    },
    riskAnalysis: {
        id: 'quoteandbind.farm.wizard.step.Risk Analysis',
        defaultMessage: 'Risk Analysis'
    },
});
